import React from 'react';

const formatNumber = (n) => Number(n || 0).toLocaleString('id-ID');

const VolunteerManagementCard = ({ data, loading, batchLabel, unavailable }) => {
  const { studentsCount, volunteerDaftar, volunteerTerpilih, volunteerDateng } = data || {};
  const baseColor = '#e91e63';

  const isEmpty = !loading && !unavailable && !studentsCount && !volunteerDaftar;

  const calculatePercentage = (part, total) => {
    if (!total || total === 0) return 0;
    return ((part / total) * 100).toFixed(0);
  };

  const convPercent = calculatePercentage(volunteerDateng, volunteerDaftar);
  const convColor = convPercent >= 50 ? '#22c55e' : convPercent >= 25 ? '#f59e0b' : baseColor;

  return (
    <div className={`card border-0 shadow-sm rounded-4 overflow-hidden h-100 management-card-v2 ${unavailable ? 'card-unavailable' : ''}`}>
      <div style={{ height: 4, backgroundColor: unavailable ? '#d9d9d9' : baseColor }}></div>
      <div className="card-body p-3">
        <div className='d-flex align-items-center gap-2 mb-1'>
          <div className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: 32, height: 32, backgroundColor: `${baseColor}15`, color: baseColor }}>
            <i className="bi bi-heart-fill small"></i>
          </div>
          <div>
            <h6 className='fw-bold mb-0 text-dark lh-sm' style={{ fontSize: '0.9rem' }}>Volunteer</h6>
            {batchLabel && (
              <div className="extra-small text-muted fw-semibold">{batchLabel}</div>
            )}
          </div>
        </div>

        <div className="mt-3">
          {loading ? (
            <div className="row g-2">
              <div className="col-5"><div className="skeleton-block rounded-3" style={{ height: 66 }}></div></div>
              <div className="col-7"><div className="skeleton-block rounded-3" style={{ height: 66 }}></div></div>
            </div>
          ) : unavailable ? (
            <div className="py-3 text-center">
              <i className="bi bi-calendar-x text-muted" style={{ fontSize: '1.25rem' }}></i>
              <div className="text-muted extra-small fw-semibold mt-1">Tidak ada batch program ini di periode terpilih</div>
            </div>
          ) : isEmpty ? (
            <div className="py-3 text-center">
              <i className="bi bi-inbox text-muted" style={{ fontSize: '1.25rem' }}></i>
              <div className="text-muted extra-small fw-semibold mt-1">Belum ada peserta di batch ini</div>
            </div>
          ) : (
            <div className="row g-2">
              <div className="col-5">
                <div className="p-2 h-100 rounded-3 bg-light text-center d-flex flex-column justify-content-center border border-white">
                  <div className="text-muted extra-small fw-bold text-uppercase mb-1">Diterima</div>
                  <div className="fw-black h4 mb-0" style={{ color: baseColor }}>{formatNumber(studentsCount)}</div>
                </div>
              </div>
              <div className="col-7">
                <div className="d-flex flex-column gap-1 h-100 justify-content-center">
                  <div className="d-flex justify-content-between align-items-center">
                    <span className="extra-small text-muted fw-bold">CONVERSION</span>
                    <span className="extra-small fw-black" style={{ color: convColor }}>{convPercent}%</span>
                  </div>
                  <div className="progress rounded-pill" style={{ height: '5px' }}>
                    <div className="progress-bar" style={{ width: `${convPercent}%`, backgroundColor: convColor, transition: 'width .4s ease' }}></div>
                  </div>
                  <div className="d-flex justify-content-between mt-1">
                    <div className="text-center">
                      <div className="mb-0 fw-bold small lh-1 text-dark">{formatNumber(volunteerDaftar)}</div>
                      <div className="text-muted extra-small">REG</div>
                    </div>
                    <div className="text-center">
                      <div className="mb-0 fw-bold small lh-1 text-dark">{formatNumber(volunteerTerpilih)}</div>
                      <div className="text-muted extra-small">SEL</div>
                    </div>
                    <div className="text-center">
                      <div className="mb-0 fw-bold small lh-1 text-dark">{formatNumber(volunteerDateng)}</div>
                      <div className="text-muted extra-small">ATT</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <style>{`
        .extra-small { font-size: 0.6rem; letter-spacing: 0.5px; }
        .fw-black { font-weight: 800; }
        .management-card-v2 { border: 1px solid #f0f0f0 !important; transition: box-shadow .2s ease, transform .2s ease; }
        .management-card-v2:hover { border-color: ${baseColor}44 !important; box-shadow: 0 10px 24px rgba(0,0,0,0.08) !important; transform: translateY(-2px); }
        .card-unavailable { opacity: 0.55; }
        .card-unavailable:hover { transform: none; box-shadow: none !important; }
        .skeleton-block { background: linear-gradient(90deg, #f0f0f0 25%, #f7f7f7 37%, #f0f0f0 63%); background-size: 400% 100%; animation: skeleton-loading 1.4s ease infinite; }
        @keyframes skeleton-loading { 0% { background-position: 100% 50%; } 100% { background-position: 0 50%; } }
      `}</style>
    </div>
  );
};

export default VolunteerManagementCard;
